module.exports = __webpack_public_path__ + "static/media/Workplace.e5ab6738.svg";